
import { Component, Vue } from "vue-property-decorator"
import { namespace, Getter, Action } from "vuex-class"

import { Team } from "@/types"
import { ViewFullSummary } from "@/types/views/viewSummary"
import User from "@/types/user"

import CaseList from "@/components/CaseList/CaseList.vue"
import CaseFilter from "@/components/CaseList/CaseFilter.vue"
import CaseFilters from "@/components/CaseList/CaseFilters.vue"
import SkeletonLoader from "@/components/SkeletonLoader.vue"
import RetractableSidebar from "@/components/RetractableSidebar.vue"

import vSelect from "vue-select"
// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"

import { ViewsService } from "@/services/viewsService"
import PageWrapper from "@/components/New/Page/PageWrapper.vue"

const caseStore = namespace("cases")
const setupStore = namespace("setup")

@Component({
	components: {
		"case-list": CaseList,
		"page": PageWrapper,
		"case-filter": CaseFilter,
		"case-filters": CaseFilters,
		"v-select": vSelect,
		"scrollbar": VuePerfectScrollbar,
		"skeleton-loader": SkeletonLoader,
		"retractable-sidebar": RetractableSidebar
	}
})
export default class CasesOverview extends Vue {
	@Getter("getMe") public me!: User;

	@Getter("getScreenWidth") public screenWidth!: number;

	@Getter("getCaseName") getCaseName!: string;
	@Getter("getRecordName") getRecordName!: string;

	@Getter("getTeams")
	public teams!: Team[];

	@caseStore.State viewsService!: ViewsService;

	@caseStore.Action public casesLoad!: () => void;
	@caseStore.Action public caseClear!: () => void;
	@Action public loadTeams!: () => void;
	@setupStore.Action public loadFieldsIfUnloaded!: () => Promise<void>;

	@caseStore.Mutation("setActiveViewId") public setActiveViewId!: (viewId: string | null) => void;

	@caseStore.Action("detailsLoad")
	private detailsLoad!: () => void;

	private get viewSummary (): ViewFullSummary | null {
		return this.viewsService.viewSummary
	}

	public async mounted () {
		this.caseClear()
		this.detailsLoad()
		this.loadFieldsIfUnloaded()

		this.viewsService.loadViews()
	}

	public async changeView (viewId: string | null) {
		this.viewsService.activeViewId = viewId
		this.viewsService.loadViews()
	}
}

